import { paymentMethodTypes, paymentPeriodTypes } from "helpers/enums";
import { ymEvent } from "helpers/system";
import React from "react";
import PhoneInput from "react-phone-input-2";
import ru from "react-phone-input-2/lang/ru";

export default function CounterpartyPlatformsForm(props) {
    const renderPlaform = (item, i) => {
        const onItemChange = ({ name, value }) => {
            props.onChange({
                name: "platforms",
                value: props.platforms.map((platform, index) =>
                    index === i ? { ...platform, [name]: value } : platform,
                ),
            });
        };
        const removeItem = () => {
            const newPlatforms = [...props.platforms];
            newPlatforms.splice(i, 1);
            props.onChange({ name: "platforms", value: newPlatforms });
        };
        return (
            <div className="card card-body bg-light p-2 mb-2" key={i}>
                <dl className="dl row">
                    <dt className="col-4">Название платформы</dt>
                    <dd className="col-8">
                        <input
                            placeholder="Название платформы"
                            className="form-control form-control-xs"
                            value={item.name ?? ""}
                            onChange={(e) => onItemChange({ name: "name", value: e.target.value })}
                        />
                    </dd>
                    <dt className="col-4">Ссылка на платформу</dt>
                    <dd className="col-8">
                        <input
                            placeholder="Ссылка на платформу"
                            className="form-control form-control-xs"
                            value={item.url ?? ""}
                            onChange={(e) => onItemChange({ name: "url", value: e.target.value })}
                        />
                    </dd>
                    <dt className="col-4">ФИО представителя</dt>
                    <dd className="col-8">
                        <input
                            placeholder="ФИО представителя"
                            className="form-control form-control-xs"
                            value={item.representativeFullName ?? ""}
                            onChange={(e) => onItemChange({ name: "representativeFullName", value: e.target.value })}
                        />
                    </dd>
                    <dt className="col-4">Email представителя</dt>
                    <dd className="col-8">
                        <input
                            placeholder="Email представителя"
                            className="form-control form-control-xs"
                            value={item.representativeEmail ?? ""}
                            type="email"
                            onChange={(e) => onItemChange({ name: "representativeEmail", value: e.target.value })}
                        />
                    </dd>
                    <dt className="col-4">Телефон представителя</dt>
                    <dd className="col-8">
                        <PhoneInput
                            country="ru"
                            localization={ru}
                            placeholder="Введите номер телефона"
                            onChange={(value) =>
                                onItemChange({ name: "representativePhoneNumber", value: `+${value}` })
                            }
                            dropdownStyle={{
                                width: "220px",
                                maxHeight: "110px",
                                margin: "5px 0",
                            }}
                            value={item.representativePhoneNumber}
                            inputClass="form-control-xs"
                        />
                    </dd>
                    <dt className="col-4">Тип оплаты</dt>
                    <dd className="col-8">
                        <select
                            className="form-control form-control-xs"
                            value={item.paymentTypeId}
                            onChange={(e) =>
                                onItemChange({
                                    name: "paymentTypeId",
                                    value: e.target.value ? Number(e.target.value) : undefined,
                                })
                            }
                        >
                            <option>Выберите тип оплаты</option>
                            {props.enums.paymentType?.map((paymentType) => (
                                <option key={paymentType.value} value={paymentType.value}>
                                    {paymentType.label}
                                </option>
                            ))}
                        </select>
                    </dd>
                    <dt className="col-4">Вид срока оплаты</dt>
                    <dd className="col-8">
                        <select
                            className="form-control form-control-xs"
                            value={item.paymentPeriodType}
                            onChange={(e) =>
                                onItemChange({
                                    name: "paymentPeriodType",
                                    value: e.target.value === "undefined" ? undefined : e.target.value,
                                })
                            }
                        >
                            <option value="undefined">Выберите вид срока оплаты</option>
                            {paymentPeriodTypes.map((periodType) => (
                                <option key={periodType.value} value={periodType.value}>
                                    {periodType.label}
                                </option>
                            ))}
                        </select>
                    </dd>
                    <dt className="col-4">Метод оплаты</dt>
                    <dd className="col-8">
                        <select
                            className="form-control form-control-xs"
                            value={item.paymentMethodType}
                            onChange={(e) =>
                                onItemChange({
                                    name: "paymentMethodType",
                                    value: e.target.value === "undefined" ? undefined : e.target.value,
                                })
                            }
                        >
                            <option value="undefined">Выберите метод оплаты</option>
                            {paymentMethodTypes.map((methodType) => (
                                <option key={methodType.value} value={methodType.value}>
                                    {methodType.label}
                                </option>
                            ))}
                        </select>
                    </dd>
                </dl>
                <div>
                    <div className="btn btn-xs btn-outline-danger float-right" onClick={removeItem}>
                        Удалить
                    </div>
                </div>
            </div>
        );
    };

    const addItem = () => {
        ymEvent("CounterpartySourceAdded");
        props.onChange({ name: "platforms", value: [...props.platforms, { name: "", url: "" }] });
    };

    return (
        <div className="row form-group">
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                Условия работы
            </label>
            <div className="col-sm-8 col-md-9">
                {props.platforms.map(renderPlaform)}
                <div className="btn btn-xs btn-secondary mr-2" onClick={addItem}>
                    Добавить
                </div>
                {props.children}
            </div>
        </div>
    );
}
